import router from "@/router";
import {getValue, goToFireStore} from "@/globalFunctions";
import {MessageBox} from "element-ui";
import i18n from "@/lang";
import {CouponModule} from "@/store/../store/modules/coupon";

export const filters = [
    {
        field: "sort",
        clearable: true,
        options: [
            { label: 'table.order.id-asc', key: 'Id-asc' },
            { label: 'table.order.id-desc', key: 'Id-desc' },
            { label: 'table.order.description-asc', key: 'Description-asc' },
            { label: 'table.order.description-desc', key: 'Description-desc' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.description',
        field: "Description"
    },
    {
        label: 'table.type',
        field: "Type",
        formatter: (x : any) => {
            return i18n.t("coupon-form." + x);
        }
    }
];

export const actions = [
    {
        label: 'table.edit',
        command: "edit",
        icon: "edit",
        type: 'info',
        click: (row : any) => {
            router.push("/ecommerce/coupons/" + row.Id);
        }
    },
    {
        label: 'table.firestore',
        command: "toFireStore",
        icon: "local_fire_department",
        type: 'warning',
        click: (row : any) => {
            goToFireStore({
                type: "coupon",
                couponId: row.Id
            });
        }
    },
    {
        label: 'table.delete',
        command: "delete",
        icon: 'delete',
        type: 'danger',
        click: (row : any) => {
            MessageBox({
                title: i18n.t('confirmations.delete-coupon.title').toString(),
                message: i18n.t('confirmations.delete-coupon.text').toString(),
                showCancelButton: true,
                confirmButtonClass: "el-button--info",
                cancelButtonClass: "el-button--danger",
                confirmButtonText: i18n.t('confirmations.default.confirmation-button').toString(),
                cancelButtonText: i18n.t('confirmations.default.cancel-button').toString(),
            }).then(async () => {
                window.GlobalEvents.$emit("start-list-load");
                return CouponModule.list.archive(row.Id).then(() => {
                    window.GlobalEvents.$emit("refresh-list");
                })
            });
        }
    }
];

export const getData = async (listQuery : any) => {
    // Get items
    if (!CouponModule.list._retrieved || !CouponModule.list._admin){
        await CouponModule.list.get(true)
    }

    let items = CouponModule.list.toList();

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
